import { Routes } from "akademika/akamont/constants/Routes";
import { FilterController } from "../sharedControllers/FilterController";

/**
 * @namespace akademika.akamont.pages.businessUnitList
 */
export default class BusinessUnitList extends FilterController {
  route = Routes.BUSINESS_UNIT_LIST;
  parentRoute = Routes.DASHBOARD;

  public onInit(): void {
    super.onInit();
    const emptyFilter = {
      sapId: undefined,
      name: undefined,
    };
    this.initFilters(emptyFilter, "api/BusinessUnit/GetBusinessUnitList");
  }

  public onViewBusinessUnit(businessUnitId: number) {
    this.navTo(Routes.BUSINESS_UNIT_DETAILS, { businessUnitId });
  }
}
